import { usePagination, useRequest } from 'ahooks'
import { useAccount, useNetwork } from 'wagmi'
import useBtcSign from './useBtcSign'
import useEvmSign from './useEvmSign'
import { getDepositList, getWithdrawList } from '@/api/account'
import { MESSAGE_1, MESSAGE_1_BTC_CACHE_KEY, MESSAGE_1_EVM_CACHE_KEY } from '@/constants'
import { getPointList } from '@/api/drop'
import { useWallet } from '@/components/common/WalletContext'
import { useBtc } from '@/context/BtcContext'

export const useDepositTableData = () => {
  const { address, publicKey, isConnected } = useBtc()
  const { data: signatureData } = useBtcSign({ message: MESSAGE_1, cacheKey: MESSAGE_1_BTC_CACHE_KEY })

  return usePagination(
    async ({ current, pageSize }) => {
      if (!isConnected) {
        return
      }
      const resp = await getDepositList({
        count: pageSize,
        offset: (current - 1) * pageSize,
        sign: { address, message: signatureData?.message, pub_key: publicKey, signature: signatureData?.signature },
      })
      return {
        total: resp.para.total,
        list: resp.para.data,
      }
    },
    {
      ready: !!signatureData?.signature && !!publicKey,
      defaultPageSize: 10,
      refreshDeps: [signatureData?.signature],
      onSuccess: (data) => {
        console.log('page: ', data)
      },
    },
  )
}

export const usePointListTableData = () => {
  const { address, publicKey, isConnected } = useBtc()

  const { walletType } = useWallet()
  const { data: signatureData } = useBtcSign({ message: MESSAGE_1, cacheKey: MESSAGE_1_BTC_CACHE_KEY })
  return usePagination(
    async ({ current, pageSize }) => {
      // if (!isConnected) {
      //   return
      // }

      const resp = await getPointList({
        count: pageSize,
        offset: (current - 1) * pageSize,
        sign:
          !!signatureData?.signature && walletType === 'Btc'
            ? {
                address,
                message: signatureData?.message,
                pub_key: publicKey,
                signature: signatureData?.signature,
              }
            : null,
      })
      if (walletType === 'Btc') {
        resp.para.data.unshift(resp.para.user || { addr: '-', point: '-', rank: '-' })
      }
      console.log('resp.para.data>>>', resp.para.data)

      return {
        total: resp.para.total,
        list: resp.para.data,
      }
    },
    {
      // ready: !!signatureData?.signature && !!publicKey,
      defaultPageSize: 10,
      refreshDeps: [signatureData?.signature, publicKey, walletType],
    },
  )
}

export const useWithdrawTableData = () => {
  const { isConnected } = useAccount()
  const { chain } = useNetwork()

  const { data: signatureData } = useEvmSign({ message: MESSAGE_1, cacheKey: MESSAGE_1_EVM_CACHE_KEY })

  return usePagination(
    async ({ current, pageSize }) => {
      if (!isConnected) {
        return
      }
      const resp = await getWithdrawList({
        count: pageSize,
        offset: (current - 1) * pageSize,
        chain_id: chain?.id,
        sign: {
          message: signatureData?.message,
          address: signatureData?.address as `0x${string}`,
          signature: signatureData?.signature.replace(/^0x/, ''),
        },
      })
      return {
        total: resp.para.total,
        list: resp.para.data,
      }
    },
    {
      ready: !!signatureData?.signature,
      defaultPageSize: 10,
      refreshDeps: [signatureData?.signature, chain?.id],
    },
  )
}

export const useWithrawPendingData = () => {
  const { data: signatureData } = useEvmSign({ message: MESSAGE_1, cacheKey: MESSAGE_1_EVM_CACHE_KEY })
  const { chain } = useNetwork()
  return useRequest(
    async () => {
      const resp = await getWithdrawList({
        count: 1000,
        offset: 0,
        sign: {
          message: signatureData?.message,
          address: signatureData?.address as `0x${string}`,
          signature: signatureData?.signature.replace(/^0x/, ''),
        },
        status: 0,
        chain_id: chain?.id,
      })
      return resp.para.data
    },
    {
      ready: !!signatureData?.signature && !!chain?.id,
      refreshDeps: [signatureData?.signature, chain],
    },
  )
}

export const useDepositPendingData = () => {
  const { address, publicKey } = useBtc()
  const { data: signatureData } = useBtcSign({ message: MESSAGE_1, cacheKey: MESSAGE_1_BTC_CACHE_KEY })
  return useRequest(
    async () => {
      const resp = await getDepositList({
        count: 1000,
        offset: 0,
        sign: { address, message: signatureData?.message, pub_key: publicKey, signature: signatureData?.signature },
        status: 0,
      })
      return resp.para.data
    },
    {
      ready: !!signatureData?.signature && !!publicKey,
      refreshDeps: [signatureData?.signature],
    },
  )
}
